import { __rest } from 'tslib';
import React from 'react';
import { DialogTitle, DialogContent, DialogContentText, DialogActions, Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';
import { PeekStack } from './PeekStack.js';
import { PeekIconButton } from './PeekIconButton.js';
import { PeekTypography } from './PeekTypography.js';
import { X } from '@piiqtechnologies/svg-icons';

const StyledTitle = styled(PeekTypography)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.h3), { fontWeight: theme.typography.fontWeightMedium })));
const DialogWithTitle = (_a) => {
    var { title, hasCloseIcon, centerTitle, children } = _a, props = __rest(_a, ["title", "hasCloseIcon", "centerTitle", "children"]);
    return (React.createElement(Dialog, Object.assign({}, props),
        title && (React.createElement(PeekDialogTitle, { sx: { p: 3.0, pb: 1.5 } },
            React.createElement(PeekStack, { direction: "row", justifyContent: centerTitle ? "center" : "space-between", alignItems: "center", sx: { position: "relative" } },
                React.createElement(StyledTitle, { textAlign: centerTitle ? "center" : "left" }, title || ""),
                hasCloseIcon && (React.createElement(PeekIconButton, { "aria-label": "Close Form", color: "primary", bordered: false, 
                    // @ts-ignore
                    onClick: props.onClose, sx: centerTitle
                        ? { position: "absolute", right: 0, top: "50%", transform: "translateY(-50%)", p: 0.5 }
                        : { p: 0.5 } },
                    React.createElement(X, { height: 16, width: 16 })))))),
        children));
};
const PeekDialog = styled(DialogWithTitle)(({ theme }) => ({}));
const PeekDialogTitle = styled(DialogTitle)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.h3), { fontWeight: theme.typography.fontWeightBold })));
const PeekDialogContent = styled(DialogContent)(({ theme }) => ({
    paddingLeft: theme.spacing(3.0),
    paddingRight: theme.spacing(3.0),
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(1.5),
}));
const PeekDialogContentText = styled(DialogContentText)(({ theme }) => ({}));
const PeekDialogActions = styled(DialogActions)(({ theme }) => ({
    paddingLeft: theme.spacing(3.0),
    paddingRight: theme.spacing(3.0),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(3.0),
    justifyContent: "center",
}));

export { PeekDialog, PeekDialogActions, PeekDialogContent, PeekDialogContentText, PeekDialogTitle, PeekDialog as default };
